import React, { useState, useEffect } from 'react';
import { ethers } from "ethers";
import { Row, Col, Card, Button } from 'react-bootstrap';
import Roadmap from '../components/Roadmaps/Roadmap';


const Home = ({ marketplace, nft }) => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  const loadMarketplaceItem = async () => {
    try {
      if (!marketplace || !nft) {
        setLoading(false);
        return;
      }

      const itemCount = await marketplace.itemCount();
      const count = Number(itemCount || 0);
      if (!count) {
        setItems([]);
        setLoading(false);
        return;
      }

      const loaded = [];
      for (let i = 1; i <= count; i++) {
        const item = await marketplace.items(i);
        if (!item.sold) {
          const uri = await nft.tokenURI(item.tokenId);
          const response = await fetch(uri);
          if (!response.ok) continue;

          const metadata = await response.json();
          const totalPrice = await marketplace.getTotalPrice(item.itemId);

          loaded.push({
            totalPrice,
            itemId: item.itemId,
            seller: item.seller,
            name: metadata?.name || 'NFT',
            description: metadata?.description || '',
            image: metadata?.image || ''
          });
        }
      }

      setItems(loaded);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const buyMarketItem = async (item) => {
    await (
      await marketplace.purchaseItem(item.itemId, { value: item.totalPrice })
    ).wait();
    loadMarketplaceItem();
  };

  useEffect(() => {
    loadMarketplaceItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <main style={{ padding: "1rem 0" }}>
        <StyleSerif />

        <Roadmap />
      </main>
    );
  }

  return (
    <div className="flex justify-center">
      <StyleSerif />

      {items.length > 0 ? (
        <div className="px-5 container">
          <Row xs={1} md={2} lg={4} className="g-4 py-5">
            {items.map((item, idx) => (
              <Col key={`${item.itemId?.toString?.() || idx}-${idx}`} className="overflow-hidden">
                <Card className="nftCard h-100">
                  <Card.Img variant="top" src={item.image} className="nftImg" alt={item.name} />
                  <Card.Body>
                    <Card.Title className="nftTitle">{item.name}</Card.Title>
                    <Card.Text className="nftDesc">{item.description}</Card.Text>
                  </Card.Body>
                  <Card.Footer className="bg-white">
                    <div className="d-grid">
                      <Button onClick={() => buyMarketItem(item)} variant="primary" size="lg" className="buyBtn">
                        Buy by {ethers.utils.formatEther(item.totalPrice)} ETH
                      </Button>
                    </div>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      ) : (
        <main style={{ padding: "1rem 0" }}>
        
          <Roadmap />
        </main>
      )}
    </div>
  );
};

/** Estilos serif elegantes (Georgia/Times) + pequeños pulidos visuales */
const StyleSerif = () => (
  <style jsx="true">{`
    /* tipografía global del componente */
    .flex, .flex * {
      font-family: Georgia, "Times New Roman", Times, serif;
      letter-spacing: 0.01em;
    }

    .nftCard {
      border: 1px solid #e6ebf1;
      border-radius: 18px;
      overflow: hidden;
      box-shadow: 0 2px 6px rgba(0,0,0,0.06);
      transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
      background: #ffffff;
    }
    .nftCard:hover {
      transform: translateY(-4px);
      box-shadow: 0 10px 28px rgba(0,0,0,0.10);
      border-color: #dbe5ef;
    }
    .nftImg { height: 260px; object-fit: cover; }
    .nftTitle {
      font-weight: 700;
      color: #0b1e3a;
      margin-bottom: .25rem;
    }
    .nftDesc { color: #4b5563; }
    .buyBtn {
      border-radius: 12px;
      font-weight: 700;
      padding: 12px 14px;
    }
  `}</style>
);

export default Home;
